import domEnums from 'app/dom_mutators/enums';
/*
 * @func updateClientUnreadButton
 *
 * @description
 * this updates the unread state of a client's custom button
 * if the customer has rendered their own button on their site
 *
 * @returns {undefined}
 */
export default function updateClientUnreadButton(unreadMessageCount) {
  const customClientButton = document.getElementById(domEnums.CUSTOM_BUTTON_ID);

  unreadMessageCount > 0
    ? customClientButton && customClientButton.classList.add(domEnums.SHOW_UNREAD_DOT)
    : customClientButton && customClientButton.classList.remove(domEnums.SHOW_UNREAD_DOT);
}
